import axios from '_u/axios'

// 查询项目列表
export const projList = (body) => {
    return axios.post('api/proj/info/list', body)
}

// 查询项目详情
export const projView = (id, viewType = 0) => {
    return axios.post('api/proj/info/view', {id, viewType})
}

// 新增项目
export const projAdd = (body) => {
    return axios.post('api/proj/info/add', body)
}

// 修改项目
export const projUpdate = (body) => {
    return axios.post('api/proj/info/update', body)
}

// 删除项目
export const projDelete = (id) => {
    return axios.post('api/proj/info/delete', {id})
}

// 查询项目列表
export const recommend = (id) => {
    return axios.post('api/proj/info/recommend', {id})
}

// 户型 --------------------------------------------
// 户型管理查询列表
export const houseList = (projId, mainHouse) => {
    return axios.post('api/proj/house/list', {projId, mainHouse})
}

// 查询户型详情
export const houseView = (id) => {
    return axios.post('api/proj/house/view', {id})
}

// 新增户型
export const houseAdd = (body) => {
    return axios.post('api/proj/house/add', body)
}

// 修改户型
export const houseUpdate = (body) => {
    return axios.post('api/proj/house/update', body)
}

// 删除户型
export const houseDelete = (id) => {
    return axios.post('api/proj/house/delete', {id})
}

// 楼栋 --------------------------------------------
// 楼栋管理查询列表
export const floorList = (projId, houseResources) => {
    return axios.post('api/proj/floor/list', {projId, houseResources})
}

// 查询楼栋详情
export const floorView = (id) => {
    return axios.post('api/proj/floor/view', {id})
}

// 新增楼栋
export const floorAdd = (body) => {
    return axios.post('api/proj/floor/add', body)
}

// 修改楼栋
export const floorUpdate = (body) => {
    return axios.post('api/proj/floor/update', body)
}

// 删除楼栋
export const floorDelete = (id) => {
    return axios.post('api/proj/floor/delete', {id})
}

// 房源 --------------------------------------------
// 房源管理查询列表
export const sourceList = (body) => {
    return axios.post('api/proj/houseresources/list', body)
}

// 查询房源详情
export const sourceView = (id) => {
    return axios.post('api/proj/houseresources/view', {id})
}

// 新增房源
export const sourceAdd = (body) => {
    return axios.post('api/proj/houseresources/add', body)
}

// 生成房源
export const genResources = (body) => {
    return axios.post('api/proj/houseresources/genResources', body)
}

// 修改房源
export const sourceUpdate = (body) => {
    return axios.post('api/proj/houseresources/update', body)
}

// 批量更新
export const batchUpdate = (list) => {
    return axios.post('api/proj/houseresources/batchUpdate', {list})
}

// 删除房源
export const sourceDelete = (id) => {
    return axios.post('api/proj/houseresources/delete', {id})
}

// 删除房源
export const queryFloor = (projId) => {
    return axios.post('api/proj/houseresources/queryFloor', {projId})
}

// 查询置业顾问列表
export const adviserList = (body) => {
    return axios.post('api/proj/info/adviserList', body)
}